import * as React from 'react'
import Zoomable from './zoomable'
import TouchAppOutlinedIcon from '@mui/icons-material/TouchAppOutlined'
const Interactive = ({
  svg,
  png,
  dld = '',
  caption,
  tooltip_id,
  id,
  interact,
  download,
  name,
  dropdown
}) => {
  const sizeCol = (caption == '') ? 'col-md-12 text-left': 'col-md-3 text-right'
  return (
    <section className='section-interactive'>
      <div id={id} className='row'>
        <div className='col-md-12'>
        <div
                className='d-none d-md-block small'
                style={{ opacity: '0.6' }}
              >
                <TouchAppOutlinedIcon></TouchAppOutlinedIcon>
                {interact}
              </div>
        </div>
        <div className='col-md-12'>
          <div
            className='d-none d-md-block position-relative'
            style={{ position: 'relative' }}
          >
            <embed
              type='image/svg+xml'
              src={svg}
              width='100%'
              height='700'
              style={{ height: 'auto' }}
            ></embed>
            <div
              id={tooltip_id}
              style={{ position: 'absolute', background: '#0a3758' }}
              className='px-2 graphtooltip'
            >
              <p>
                <span
                  className='name'
                  style={{
                    color: '#ffffff',
                    fontFamily: 'freight-big-pro, serif',
                    fontWeight: '900',
                    fontSize: '21px'
                  }}
                ></span>
                <br></br>
                <span className='conflict orange'></span>
                <span className='colon' style={{ color: '#ffffff' }}></span>
                <span className='disaster blue'></span>
                <span className='youth purple'></span>
              </p>
            </div>
          </div>
          <div className='d-md-none'>
            <Zoomable
              src={png}
              alt={caption}
              zoom='200'
              dld=''
              name={name}
              dropdown = {dropdown}
            />
          </div>
        </div>
        <div className={dld != '' ? 'col-md-9' : 'col-md-12'}>
          <figure>
            <figcaption>
              <span className='small'>{caption}</span>
              
            </figcaption>
          </figure>
        </div>
        {dld != '' ? (
          <div className={sizeCol}>
            <a
              className='download-infographic fw-normal is-button'
              href={dld}
              download
              data-name={name}
              target='_blank'
            >
              {' '}
              {download} <span className='arr'>→</span>
            </a>
          </div>
        ) : null}
      </div>
    </section>
  )
}

export default Interactive
